
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifecycle-studio/messages",
      function () {
        return require("private-next-pages/lifecycle-studio/messages.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifecycle-studio/messages"])
      });
    }
  